import './verticalTextSlider.css';

export default function VerticalTextSlider() {
    return(
    <div className="content">
            <div className="slider-wrapper">
                A
                <div className="slider">
                    <div className="slider-text-1">
                        Product Manager
                    </div>
                    <div className="slider-text-2">
                        Film Photographer
                    </div>
                    <div className="slider-text-3">
                        Elmo Enthusiast
                    </div>
                </div>
            </div>
        </div>
    )
}